<template>
  <div id="mutualHelpList-page">
    <div class="quesInner">
      <div class="listTop">
        <div class="listTopTextBox">
          <span>活动招募</span>
        </div>
        <div class="bottomLine"></div>
      </div>
      <div class="quesList">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="list.length?'没有更多了':''"
          @load="onLoad"
        >
          <div
            class="comCard"
            v-for="item in list"
            :key="item.id"
          >
            <div
              class="cardTitle"
              :style="{color:item.questionnaireType!=='Base'?'#3C50E0':'#DC9B39'}"
            >{{item.questionnaireType=='Base'?'基础问卷':'活动招募'}}</div>
            <div class="cardInner clearFix">
              <div class="cardInnerLeft">
                <div class="quesName">{{item.title}}</div>
                <div class="queEndTime">{{`截止时间：${item.expiryTime?item.expiryTime:'无'}`}}</div>
              </div>
              <div class="cardInnerRight">
                <div class="queMoney">{{`${item.unitPrice}元`}}</div>
                <div class="payCode">{{'2天内即付'}}</div>
              </div>
            </div>
            <div class="cardFooter">
              <van-button
                :disabled="item.isAnswer||item.isExpiry"
                @click="toUrl(item.questionnaireUrl)"
                class="mr30"
                round
                type="primary"
                size="small"
                :color="(item.isAnswer||item.isExpiry)?'#cccccc':'#3C50E0'"
              >立刻参与</van-button>
              <van-button
                :disabled="item.isExpiry"
                @click="shareConfig(item)"
                round
                type="primary"
                size="small"
                :color="item.isExpiry?'#cccccc':'#F46B6B'"
              >推荐给好友</van-button>
            </div>
          </div>
        </van-list>
        <van-empty
          description="暂无活动招募"
          v-show="list.length<=0&&finished"
        />
      </div>
    </div>
    <van-overlay
      :show="overlayShow"
      @click="overlayShow = false"
    >
      <div class="arrow"></div>
      <div class="wrapper">
        <div class="block">
          <p>请点击右上角的...</p>
          <p>进行分享！</p>
          <!-- <p>您将获得好友答题酬金</p>
          <p>金额<span style="font-size:20px;">10%</span>的佣金奖励！</p> -->
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { wxConfigFn } from '../../utils/utils'
export default {
  data() {
    return {
      list: [],
      pageIndex: 1,
      loading: false,
      finished: false,
      overlayShow: false,
      currentTitle: '',
    }
  },
  components: {},
  async created() {
    if (navigator.userAgent.indexOf('iPhone') !== -1) {
      // 兼容ios 生成签名的当前页面地址取值 ios url地址为入口地址
      if (window.wechaturl === undefined) {
        window.wechaturl = window.location + ''
      }
    }
    let url = window.location.href
    if (window.wechaturl !== undefined) {
      // ios 取真正的url，即入口url
      url = window.wechaturl
    }
    // 配置分享
    wxConfigFn(url, ['updateAppMessageShareData', 'updateTimelineShareData'])
  },
  methods: {
    // 上拉加载问卷
    onLoad() {
      this.getQuesList()
    },
    // 获取问卷列表
    async getQuesList() {
      let params = {
        pageSize: 10,
        pageIndex: this.pageIndex,
      }
      let quesData = await $api.getUsualQuestionnaires(params)
      if (quesData) {
        // 当请求回来的数据长度大于0，则pageIndex+1，从而实现分页请求
        if (quesData.rows.length) {
          this.pageIndex++
          this.list.push(...quesData.rows)
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
      }
      this.loading = false
    },
    // 进入问卷详情
    toUrl(url) {
      this.$router.push({
        path: '/questionnaire',
        query: {
          outPath: url,
        },
      })
    },
    // 分享配置
    shareConfig(data) {
      let _this = this
      this.overlayShow = true
      this.currentTitle = data.title
      let shareData = data
      let shareDataEnCodeUrl = encodeURIComponent(shareData.questionnaireUrl)
      let shareuserId = JSON.parse(window.localStorage.getItem('userInfo')).id
      let basePath = process.env.VUE_APP_BaseURL
      console.log(
        '分享链接---' +
          `${basePath}/questionnaire?shareuserId=${shareuserId}&outPath=${shareDataEnCodeUrl}`
      )
      wx.ready(function () {
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: '答问卷，领酬金！', // 分享标题
          desc: `${shareData.title}，${shareData.unitPrice}元`, // 分享描述
          link: `${basePath}/questionnaire?shareuserId=${shareuserId}&outPath=${shareDataEnCodeUrl}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            'https://pfg-1.oss-cn-shenzhen.aliyuncs.com/static/img/wjhb.jpeg', // 分享图标
          success: function () {
            // 设置成功
            console.log('设置成功1')
          },
        })
        wx.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          wx.updateTimelineShareData({
            title: '答问卷，领酬金！', // 分享标题
            link: `${basePath}/questionnaire?shareuserId=${shareuserId}&outPath=${shareDataEnCodeUrl}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl:
              'https://pfg-1.oss-cn-shenzhen.aliyuncs.com/static/img/wjhb.jpeg', // 分享图标
            success: function () {
              // 设置成功
              console.log('设置成功2')
            },
          })
        })
      })
    },
  },
}
</script>
<style lang='less'>
#mutualHelpList-page {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 20px 0;
  overflow: auto;
  background: url('../../assets/images/bg.png');
  .quesInner {
    width: 100%;
    height: 100%;
    .listTop {
      .listTopTextBox {
        font-size: 18px;
        color: #fff;
        height: 32px;
        line-height: 32px;
        padding-left: 25px;
        font-style: italic;
        letter-spacing: 3px;
        background: @colorDefault;
        margin-bottom: 4px;
      }
      .bottomLine {
        height: 2px;
        background-color: @colorDefault;
      }
      margin-bottom: 10px;
    }
    .quesList {
      height: calc(100vh - 70px - 40px);
      overflow: auto;
    }
  }
  .comCard {
    height: 120px;
    background: #fff;
    border-radius: 2px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 3px 0px rgba(85, 85, 85, 0.05);
    margin-bottom: 10px;
    padding: 6px 25px 0;
    .cardTitle {
      font-size: 12px;
      color: #5c5b5b;
      line-height: 24px;
      border-bottom: 1px solid rgba(210, 210, 210, 1);
    }
    .cardInner {
      padding-top: 6px;
      margin-bottom: 7px;
      .cardInnerLeft {
        float: left;
        .quesName {
          height: 28px;
          font-size: 13px;
          line-height: 28px;
          color: #5c5b5b;
          width: 180px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .queEndTime {
          line-height: 14px;
          font-size: 10px;
          color: #5c5b5b;
        }
      }
      .cardInnerRight {
        float: right;
        .queMoney {
          height: 28px;
          font-size: 18px;
          line-height: 28px;
          color: #5c5b5b;
          text-align: right;
          color: @colorDefault;
        }
        .payCode {
          line-height: 14px;
          font-size: 10px;
          color: #5c5b5b;
          text-align: right;
        }
      }
    }
    .cardFooter {
      display: flex;
      justify-content: center;
      .van-button--small {
        &.mr30 {
          margin-right: 30px;
        }
        padding: 0;
        width: 80px;
      }
    }
  }
  .clearFix:after {
    content: '';
    display: block;
    clear: both;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 180px;
    height: 133px;
    font-size: 14px;
    color: #fff;
    background-color: #fff;
    background-image: linear-gradient(45deg, #3c50e0, #f46b6b);
    border-radius: 10px;
    padding-left: 40px;
    padding-top: 10px;
    p {
      line-height: 1;
    }
  }
  .arrow {
    width: 30px;
    height: 41px;
    background: url('../../assets/images/shareArrow3.png') center center;
    background-size: 100% 100%;
    position: absolute;
    top: 88px;
    right: 52px;
  }
}
</style>
